"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _goods = require("@/api/goods/goods");
var _shopList = require("@/api/shop/shopList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
// import { get } from 'sortablejs'
var _default = exports.default = {
  name: 'estimateInfo',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  props: {
    goodsId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: [],
      total: null,
      listLoading: true,
      shopLoading: false,
      searchStoreKeyword: '',
      selectedShopItem: null,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        dataId: null,
        storeId: null,
        storeName: null
      },
      resPath: process.env.VUE_IMAGE_PATH,
      shopList: []
    };
  },
  created: function created() {
    this.getList();
    this.loadDefaultShops();
  },
  computed: {},
  methods: {
    getRowKey: function getRowKey(row) {
      return row.id + '_' + row.name + '_' + row.data;
    },
    // 远程搜索门店（对接后台接口，按门店名称搜索）
    searchShop: function searchShop(query) {
      var _this = this;
      this.searchStoreKeyword = query ? query.trim() : '';
      if (this.searchStoreKeyword) {
        this.shopLoading = true;
        (0, _shopList.getshopList)({
          storeName: this.searchStoreKeyword,
          page: 1,
          limit: 50
        }).then(function (res) {
          _this.shopLoading = false;
          if (res && res.records) {
            _this.shopList = res.records;
            // 确保已选中的门店项保留在下拉列表中，避免显示为 ID
            if (_this.listQuery.storeId && _this.selectedShopItem && !_this.shopList.some(function (item) {
              return item.storeId === _this.listQuery.storeId;
            })) {
              _this.shopList.unshift(_this.selectedShopItem);
            }
          }
        }).catch(function () {
          _this.shopLoading = false;
        });
      } else {
        this.loadDefaultShops();
      }
    },
    // 加载默认门店列表
    loadDefaultShops: function loadDefaultShops() {
      var _this2 = this;
      (0, _shopList.getshopList)({
        page: 1,
        limit: 50
      }).then(function (res) {
        if (res && res.records) {
          _this2.shopList = res.records;
          if (_this2.listQuery.storeId && _this2.selectedShopItem && !_this2.shopList.some(function (item) {
            return item.storeId === _this2.listQuery.storeId;
          })) {
            _this2.shopList.unshift(_this2.selectedShopItem);
          }
        }
      });
    },
    handleShopChange: function handleShopChange(val) {
      if (val) {
        var found = this.shopList.find(function (item) {
          return item.storeId === val;
        });
        if (found) {
          this.selectedShopItem = found;
        }
        this.searchStoreKeyword = '';
      } else {
        this.selectedShopItem = null;
      }
      this.handleFilter();
    },
    handleClearShop: function handleClearShop() {
      this.listQuery.storeId = null;
      this.listQuery.storeName = null;
      this.searchStoreKeyword = '';
      this.selectedShopItem = null;
      this.loadDefaultShops();
      this.handleFilter();
    },
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      this.listQuery.dataId = this.goodsId;
      // 若选中具体门店，按 storeId 过滤；若未选具体门店但输入了关键字，按 storeName 过滤
      if (this.listQuery.storeId) {
        this.listQuery.storeName = null;
      } else if (this.searchStoreKeyword) {
        this.listQuery.storeName = this.searchStoreKeyword;
      } else {
        this.listQuery.storeName = null;
      }
      (0, _goods.getGoodsEstimateInfo)(this.listQuery).then(function (response) {
        if (response) {
          _this3.dataList = response.data.records;
          _this3.total = response.data.total;
        }
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.limit = size;
      this.listQuery.page = 1;
      this.getList();
    }
  }
};